import styled from '@emotion/styled/macro';
import Divider from '@mui/material/Divider';

// Menu items come and go with permissions, so a divider cannot know in advance whether it
// still separates anything, and drops itself once it leads, follows another, or trails.
// Read the last rule inside-out: :not(&) is "a menu item", so the rule matches a divider
// with no menu item anywhere after it. The ~ is what collapses a trailing run of any length
// -- with + it could only see the neighbour, and a third divider would survive.
const MenuDivider = styled(Divider)`
  &:first-child,
  & + &,
  &:not(:has(~ :not(&))) {
    display: none;
  }
`;

// MenuList would otherwise open with the divider as its active item, leaving the arrow keys
// with nothing to walk from
MenuDivider.muiSkipListHighlight = true;

export default MenuDivider;
